export default __webpack_public_path__ + "static/media/cvhnet1.d8ff3798.png";